import Status from "./status";

class QuestionnaireStatus extends Status {
}

export default QuestionnaireStatus;
